import * as React from "react";

import styles from "./ActivityIndicator.scss";
import icon from "../../static/brand/icon200.png";

export interface IActivityIndicatorProps {
	size?: number | "sm" | "lg";
	color?: string;
	useIcon?: boolean;
}

export function ActivityIndicator(props: IActivityIndicatorProps) {
	let useIcon = props.useIcon;
	let color = props.color || "#03a9f4";
	let size = props.size || "sm";
	switch (size) {
		case "sm": size = 16; break;
		case "lg": size = 50; break;
	}

	// if not defined, use fleetplan icon for big indicators
	if (useIcon == null && size > 32) {
		useIcon = true;
	}

	let content: React.ReactNode = "";
	let spinClass = styles.spin;
	if (useIcon) {
		spinClass += " " + styles.slow;
		content = <img src={icon} height="100%" width="100%"/>;
	} else {
		content = <svg viewBox="0 0 32 32" height="100%" width="100%">
			<circle cx="16" cy="16" fill="none" r="14" strokeWidth="4" style={{ stroke: color, opacity: 0.2 }}/>
			<circle cx="16" cy="16" fill="none" r="14" strokeWidth="4" style={{ stroke: color, strokeDasharray: 80, strokeDashoffset: 60 }}/>
		</svg>;
	}

	let boxSize = { width: `${size}px`, height: `${size}px` };
	return <i className={spinClass} style={boxSize}>{content}</i>;
}



// WEBPACK FOOTER //
// ./src/common/ActivityIndicator/ActivityIndicator.tsx